export enum ContentAssetsLayout {
  LIST,
  TILES,
}
